import { Sport } from '@sorare/core/src/__generated__/globalTypes';

import { SORTS as FOOTBALL_SORTS } from '#src/searchCards/football/sorts.ts';
import { SORTS as BASEBALL_SORTS } from '#src/searchCards/mlb/sorts.ts';
import { SORTS as NBA_SORTS } from '#src/searchCards/nba/sorts.ts';
import {
  scoutingCenterMarketDropdownFilters as BASEBALL_DROPDOWN_FILTERS,
  scoutingCenterMarketFilters as BASEBALL_FILTERS,
} from '#src/searchCommonPlayer/filtersGroup/baseball.tsx';
import {
  scoutingCenterMarketDropdownFilters as FOOTBALL_DROPDOWN_FILTERS,
  scoutingCenterMarketFilters as FOOTBALL_FILTERS,
} from '#src/searchCommonPlayer/filtersGroup/football.tsx';
import {
  scoutingCenterMarketDropdownFilters as NBA_DROPDOWN_FILTERS,
  scoutingCenterMarketFilters as NBA_FILTERS,
} from '#src/searchCommonPlayer/filtersGroup/nba.tsx';

export const SORTS_BY_SPORT = {
  [Sport.NBA]: NBA_SORTS,
  [Sport.BASEBALL]: BASEBALL_SORTS,
  [Sport.FOOTBALL]: FOOTBALL_SORTS,
};

export const FILTERS_BY_SPORT = {
  [Sport.NBA]: NBA_FILTERS,
  [Sport.BASEBALL]: BASEBALL_FILTERS,
  [Sport.FOOTBALL]: FOOTBALL_FILTERS,
};

export const DROPDOWN_FILTERS_BY_SPORT = {
  [Sport.NBA]: NBA_DROPDOWN_FILTERS,
  [Sport.BASEBALL]: BASEBALL_DROPDOWN_FILTERS,
  [Sport.FOOTBALL]: FOOTBALL_DROPDOWN_FILTERS,
};
